// blurbTemplates.js
export const blurb_classic_template_1 = [
    [
        'vayu-blocks/advance-container',
        {
            advPadding: {
                Desktop: {
                  top: '40px',
                  right: '40px',
                  bottom: '40px',
                  left: '40px',
                },
                Tablet: {
                    top: '40px',
                  right: '40px',
                  bottom: '40px',
                  left: '40px',
                },
                Mobile: {
                    top: '40px',
                  right: '40px',
                  bottom: '40px',
                  left: '40px',
                },
              },
              contFlex: {
              rwGap: {
                Desktop: '30px',
                Tablet: '30px',
                Mobile: '30px',
              },
              colGap: {
                Desktop: '30px',
                Tablet: '30px',
                Mobile: '30px',
              },
              direction:{},
              justifyConten:{},
              alignItems:{},
              wrap:{},
              alignContent:{}
            },
            advBackground: {
                type: 'color',
                color: '#0D0D0D',
                image: {
                    url: ''
                },
                gradient: 'linear-gradient(135deg,#0F2027 0%, #203A43 0%, #2C5364 100%)'
              },
        },
        [
            [
                'vayu-blocks/advance-container',
                {
                    advPadding: {
                        Desktop: {
                          top: '0px',
                          right: '0px',
                          bottom: '0px',
                          left: '0px',
                        },
                        Tablet: {
                            top: '0px',
                          right: '0px',
                          bottom: '0px',
                          left: '0px',
                        },
                        Mobile: {
                            top: '0px',
                          right: '0px',
                          bottom: '0px',
                          left: '0px',
                        },
                      },
                      contFlex: {
                        rwGap: {
                          Desktop: '0px',
                          Tablet: '0px',
                          Mobile: '0px',
                        },
                        colGap: {
                          Desktop: '0px',
                          Tablet: '0px',
                          Mobile: '0px',
                        },
                        direction:{},
                        justifyConten:{},
                        alignItems:{},
                        wrap:{},
                        alignContent:{}
                      }
                },
                [
                    [
                        'vayu-blocks/icon',
                        {
                            alignment:{
                            Desktop: 'center',
                            Tablet: 'center',
                            Mobile: 'center',
                        },
                            color:'#e8383e',
                            hoverColor:'#e8383e',
                        }
                    ]
                ]
            ],
            [
                'vayu-blocks/advance-container',
                {
                    advPadding: {
                        Desktop: {
                          top: '0px',
                          right: '0px',
                          bottom: '0px',
                          left: '0px',
                        },
                        Tablet: {
                            top: '0px',
                          right: '0px',
                          bottom: '0px',
                          left: '0px',
                        },
                        Mobile: {
                            top: '0px',
                          right: '0px',
                          bottom: '0px',
                          left: '0px',
                        },
                      }
                    
                },
                [
                    [
                        'vayu-blocks/advance-heading',
                        {
                            typography : {
                                fonts: {},
                                fontSize: {
                                Desktop: '13px',
                                Tablet: '13px',
                                Mobile: '13px'
                                },
                                appearance: 'bold',
                                lineHeights: {},
                                letterSpacing: {},
                                decoration: {},
                                orientation: {},
                                letterCase: {}
                                },
                            content: 'Lorem Ipsum',
                            align: {
                               Desktop: 'center',
                                Tablet: 'center',
                                Mobile: 'center' 
                            },
                            headingColor:'#fff'
                        }
                    ],
                    [
                        'vayu-blocks/advance-heading',
                        {
                            typography : {
                                fonts: {},
                                fontSize: {
                                Desktop: '14px',
                                Tablet: '14px',
                                Mobile: '14px'
                                },
                                appearance: 'bold',
                                lineHeights: {},
                                letterSpacing: {},
                                decoration: {},
                                orientation: {},
                                letterCase: {}
                                },
                            content: 'Neque porro quisquam est qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit...',
                            align: {
                                Desktop: 'center',
                                 Tablet: 'center',
                                 Mobile: 'center' 
                             },
                            headingColor:'#fff'
                        }
                    ],
                    [
                        'vayu-blocks/advance-button',
                        {
                            btnBackground: {
                                type: 'color',
                                color: '#E8383E',
                                image: {
                                    url: ''
                                },
                                gradient: 'linear-gradient(135deg,#0F2027 0%, #203A43 0%, #2C5364 100%)'
                              },
                            btnPadding: {
                                Desktop: {
                                  top: '10px',
                                  right: '25px',
                                  bottom: '10px',
                                  left: '25px',
                                },
                                Tablet: {
                                },
                                Mobile: {
                                },
                              },
                              alignment: {
                                Desktop: 'center',
                                 Tablet: 'center',
                                 Mobile: 'center' 
                             },
                             btnBorderRadius: {
                                Desktop: '25px',
                                 Tablet: '25px',
                                 Mobile: '25px' 
                             },

                        }
                    ]
                ]
            ]
        ]
    ]
];

export const blurb_classic_template_2 = [
    [
        'vayu-blocks/advance-container',
        {
            advPadding: {
                Desktop: {
                  top: '40px',
                  right: '40px',
                  bottom: '40px',
                  left: '40px',
                },
                Tablet: {
                    top: '40px',
                  right: '40px',
                  bottom: '40px',
                  left: '40px',
                },
                Mobile: {
                    top: '40px',
                  right: '40px',
                  bottom: '40px',
                  left: '40px',
                },
              },
              contFlex: {
                rwGap: {
                  Desktop: '30px',
                  Tablet: '30px',
                  Mobile: '30px',
                },
                colGap: {
                  Desktop: '30px',
                  Tablet: '30px',
                  Mobile: '30px',
                },
                direction:{
                Desktop: 'row',
                  Tablet: 'row',
                  Mobile: 'row',
                },
                justifyConten:{},
                alignItems:{},
                wrap:{},
                alignContent:{}
              },
           
        },
        [    [
                'vayu-blocks/advance-container',
                {
                    advPadding: {
                        Desktop: {
                          top: '20px',
                          right: '20px',
                          bottom: '20px',
                          left: '20px',
                        },
                        Tablet: {
                            top: '20px',
                          right: '20px',
                          bottom: '20px',
                          left: '20px',
                        },
                        Mobile: {
                            top: '20px',
                          right: '20px',
                          bottom: '20px',
                          left: '20px',
                        },
                      },
                      contFlex: {
                        rwGap: {
                          Desktop: '0px',
                          Tablet: '0px',
                          Mobile: '0px',
                        },
                        colGap: {
                            Desktop: '0px',
                            Tablet: '0px',
                            Mobile: '0px',
                        },
                        direction:{
                        Desktop: 'row',
                          Tablet: 'row',
                          Mobile: 'row',
                        },
                        justifyConten:{},
                        alignItems:{},
                        wrap:{},
                        alignContent:{}
                      },
                      advBackground: {
                        type: 'color',
                        color: '#4C38C9',
                        image: {
                            url: ''
                        },
                        gradient: 'linear-gradient(135deg,#0F2027 0%, #203A43 0%, #2C5364 100%)'
                      },
                },
                [
                    [
                        'vayu-blocks/icon',
                        {
                            
                            paddingUnit:'px',
                            iconAnimation:'icon-bounce',
                            color:'#fff'
                        }
                    ]
                ]
            ],
            [
                'vayu-blocks/advance-container',
                {
                    advPadding: {
                        Desktop: {
                          top: '0px',
                          right: '0px',
                          bottom: '0px',
                          left: '0px',
                        },
                        Tablet: {
                            top: '0px',
                          right: '0px',
                          bottom: '0px',
                          left: '0px',
                        },
                        Mobile: {
                            top: '0px',
                          right: '0px',
                          bottom: '0px',
                          left: '0px',
                        },
                      },
                      contFlex: {
                      rwGap: {
                        Desktop: '20px',
                        Tablet: '20px',
                        Mobile: '20px',
                      },
                      colGap: {
                        Desktop: '20px',
                        Tablet: '20px',
                        Mobile: '20px',
                      },
                      direction:{},
                      justifyConten:{},
                      alignItems: {
                        Desktop: 'flex-start',
                        Tablet: '',
                        Mobile: ''
                      },
                      wrap:{},
                      alignContent:{}
                    },
                },
                [
                    [
                        'vayu-blocks/advance-heading',
                        {
                            typography : {
                                fonts: {},
                                fontSize: {
                                Desktop: '13px',
                                Tablet: '13px',
                                Mobile: '13px'
                                },
                                appearance: 'bold',
                                lineHeights: {},
                                letterSpacing: {},
                                decoration: {},
                                orientation: {},
                                letterCase: {}
                                },
                            content: 'Lorem Ipsum',
                            headingColor:'#333'
                        }
                    ],
                    [
                        'vayu-blocks/advance-heading',
                        {
                            typography : {
                                fonts: {},
                                fontSize: {
                                Desktop: '14px',
                                Tablet: '14px',
                                Mobile: '14px'
                                },
                                appearance: 'bold',
                                lineHeights: {},
                                letterSpacing: {},
                                decoration: {},
                                orientation: {},
                                letterCase: {}
                                },
                            content: 'Neque porro quisquam est qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit...',
                            headingColor:'#333'
                        }
                    ],
                ]
            ]
        ]
    ]
];

export const blurb_flipbox_template_1 = [
    [
        'vayu-blocks/flip-box', 
        {
          imagehvreffect: "flip" // 
        }, 
        [
            [
                'vayu-blocks/flip-wrapper', 
                {
                    className: 'vayu_blocks_flip-box-front front',
                    flipSide: 'front',
                    flipBackground: {
                        type: 'color',
                        color: '#0d0d0d',
                        image: {
                            url: ''
                        },
                        gradient: 'linear-gradient(135deg,#0F2027 0%, #203A43 0%, #2C5364 100%)'
                      },
                },
                [
                    [
                        'vayu-blocks/advance-container',
                        {
                            advPadding: {
                                Desktop: {
                                  top: '40px',
                                  right: '40px',
                                  bottom: '40px',
                                  left: '40px',
                                },
                                Tablet: {
                                    top: '40px',
                                  right: '40px',
                                  bottom: '40px',
                                  left: '40px',
                                },
                                Mobile: {
                                    top: '40px',
                                  right: '40px',
                                  bottom: '40px',
                                  left: '40px',
                                },
                              },
                              contFlex: {
                              rwGap: {
                                Desktop: '21px',
                                Tablet: '21px',
                                Mobile: '21px',
                              },
                              colGap: {
                                Desktop: '21px',
                                Tablet: '21px',
                                Mobile: '21px',
                              },
                              direction:{},
                              justifyConten:{},
                              alignItems: {
                                Desktop: 'center',
                                Tablet: '',
                                Mobile: ''
                              },
                              wrap:{},
                              alignContent:{}
                            },
                        },
                        [
                            [
                                'vayu-blocks/icon',
                                {
                                    iconAnimation: 'icon-bounce',
                                    color:'#e8383e',
                                    hoverColor:'#e8383e',
                                }
                            ],
                            [
                                'vayu-blocks/advance-heading',
                                {
                                    typography : {
                                        fonts: {},
                                        fontSize: {
                                        Desktop: '13px',
                                        Tablet: '13px',
                                        Mobile: '13px'
                                        },
                                        appearance: 'bold',
                                        lineHeights: {},
                                        letterSpacing: {},
                                        decoration: {},
                                        orientation: {},
                                        letterCase: {}
                                        },
                                    content: 'Lorem Ipsum',
                                    headingColor: '#fff',
                                    align:{
                                        Desktop: 'center',
                                        Tablet: 'center',
                                        Mobile: 'center'
                                    }
                                }
                            ]
                        ]
                    ]
                ]
            ],
            [
                'vayu-blocks/flip-wrapper', 
                {
                    className: 'vayu_blocks_flip-box-back back',
                    flipSide: 'back',
                     flipBackground: {
                        type: 'color',
                        color: '#d1477c',
                        image: {
                            url: ''
                        },
                        gradient: 'linear-gradient(135deg,#0F2027 0%, #203A43 0%, #2C5364 100%)'
                      },
                },
                [
                    [
                        'vayu-blocks/advance-container',
                        {
                            advPadding: {
                                Desktop: {
                                  top: '40px',
                                  right: '40px',
                                  bottom: '40px',
                                  left: '40px',
                                },
                                Tablet: {
                                    top: '40px',
                                  right: '40px',
                                  bottom: '40px',
                                  left: '40px',
                                },
                                Mobile: {
                                    top: '40px',
                                  right: '40px',
                                  bottom: '40px',
                                  left: '40px',
                                },
                              },
                              contFlex: {
                              rwGap: {
                                Desktop: '21px',
                                Tablet: '21px',
                                Mobile: '21px',
                              },
                              colGap: {
                                Desktop: '21px',
                                Tablet: '21px',
                                Mobile: '21px',
                              },
                              direction:{},
                              justifyConten:{},
                              alignItems: {
                                Desktop: 'center',
                                Tablet: '',
                                Mobile: ''
                              },
                              wrap:{},
                              alignContent:{}
                            },
                        },
                        [
                            
                            [
                                'vayu-blocks/advance-heading',
                                {
                                    typography : {
                                        fonts: {},
                                        fontSize: {
                                        Desktop: '13px',
                                        Tablet: '13px',
                                        Mobile: '13px'
                                        },
                                        appearance: 'bold',
                                        lineHeights: {},
                                        letterSpacing: {},
                                        decoration: {},
                                        orientation: {},
                                        letterCase: {}
                                        },
                                    content: 'Lorem Ipsum',
                                    headingColor: '#fff',
                                    align: {
                                        Desktop: 'center',
                                         Tablet: 'center',
                                         Mobile: 'center' 
                                     },
                                }
                            ],
                            [
                                'vayu-blocks/advance-heading',
                                {
                                    typography : {
                                        fonts: {},
                                        fontSize: {
                                        Desktop: '14px',
                                        Tablet: '14px',
                                        Mobile: '14px'
                                        },
                                        appearance: 'bold',
                                        lineHeights: {},
                                        letterSpacing: {},
                                        decoration: {},
                                        orientation: {},
                                        letterCase: {}
                                        },
                                    content: 'Neque porro quisquam est qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit...',
                                    headingColor:'#fff',
                                    align: {
                                        Desktop: 'center',
                                         Tablet: 'center',
                                         Mobile: 'center' 
                                     },
                                }
                            ],
                            [
                                'vayu-blocks/advance-button',
                                {
                                    btnBackground: {
                                        type: 'color',
                                        color: '#e8383e',
                                        image: {
                                            url: ''
                                        },
                                        gradient: 'linear-gradient(135deg,#0F2027 0%, #203A43 0%, #2C5364 100%)'
                                      },
                                      btnPadding: {
                                        Desktop: {
                                          top: '10px',
                                          right: '25px',
                                          bottom: '10px',
                                          left: '25px',
                                        },
                                        Tablet: {
                                        },
                                        Mobile: {
                                        },
                                      },
                                      alignment: {
                                        Desktop: 'center',
                                         Tablet: 'center',
                                         Mobile: 'center' 
                                     },
                                     btnBorderRadius: {
                                        Desktop: '25px',
                                         Tablet: '25px',
                                         Mobile: '25px' 
                                     },
        
                                }
                            ]
                        ]
                    ]
                ]
            ]
        ]
    ]
];


export const blurb_flipbox_template_2 = [
  [
      'vayu-blocks/flip-box', 
      {
        imagehvreffect: "slide" // <-- default attribute added here
      }, 
  ]
];